import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import {
    addActivity,
    editActivity,
    getActivity
} from '../../../helper/Api';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomBreadcrumbs from '../../Tools/Breadcumbs';
import {
  FormControl,
  TextField
} from "@mui/material";
const AddActivity = () => {
    const { id } = useParams();
    const { authData } = useSelector((state) => state.authData);
    const [formData, setFormData] = useState({
        status: "1",
        activity: '',
        created_by: authData.user.id,
    });
    const navigate = useNavigate();
    const handleToggle = () => {
        setFormData({
            ...formData,
            status: formData.status === "0" ? "1" : "0",
        });
    }
    const handleFormData = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData({
            ...formData,
            [name]: value
        });
    }
    const previewHandler = (e) => {
        e.preventDefault();
    };
    const validateForm = (data) => {
        if (!formData.activity) {
            return false;
        }
        return true;
    };
    const fetchData = async (id) => {
        const response = await getActivity(id);
        if (response.data.status) {
            setFormData(response.data.result[0])
        }
    }
    useEffect(() => {
        if (id) {
            fetchData(id);
        }
    }, [id]);

    const handleSubmit = async (e) => {
        if (!validateForm()) {
            alert('Activity is required.');
            return;
        }
        try {
            if (id) {
                const response = await editActivity({ activity: formData.activity, status: formData.status }, id);
                if (response.data.status) {
                    toast.success(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    navigate('/department/activity');
                } else {
                    toast.error(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
            else {
                const response = await addActivity({ activity: formData.activity });
                if (response.data.status) {
                    toast.success(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    navigate('/department/activity');
                } else {
                    toast.error(response.data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }
      const linksArray = [
        {
          href: "/department/activity",
          label: "Activities",
        }
      ]
    return (
        <div>
            <div className="p-3">
                <div className="row">
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>Add Activity</h4>
                        <CustomBreadcrumbs linksArray={linksArray} title="Add Acitivity"/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            <button
                                type="button"
                                className="submit_button"
                                onClick={handleSubmit}
                                ><span className="fs-14px">Save</span>
                            </button>
                        </div>
                        
                    </div>
                </div>
                <div className="row">
                    <Form onSubmit={previewHandler}>
                        <div className="col-md-12">
                            <div className="card p-3 mt-3">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id="activity"
                                                        label="Activity Name"
                                                        variant="outlined"
                                                        type="text"
                                                        name="activity"
                                                        value={formData.activity || ""}
                                                        onChange={handleFormData}
                                                        required
                                                    />
                                                </FormControl>
                                            </div>
                                            {id && (
                                                <div className="col-sm-6">
                                                    <div className="form-group row">
                                                        <label htmlFor="inputType" className="col-sm-4 col-form-label">
                                                            Status
                                                            <span className="text-danger">*</span> :
                                                        </label>
                                                        <div className="col-sm-8">
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    id="active"
                                                                    name="status"
                                                                    value={formData.status} onChange={handleToggle}
                                                                    checked={formData.status === "1"}
                                                                />
                                                                <label className="form-check-label" htmlFor="active">
                                                                    Active
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    id="inactive"
                                                                    name="status"
                                                                    value={formData.status}
                                                                    onChange={handleToggle}
                                                                    checked={formData.status === "0"}
                                                                />
                                                                <label className="form-check-label" htmlFor="inactive">
                                                                    Inactive
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )

};
export default AddActivity;